import React from "react"

import { useTranslations } from "@cirrus/core/i18n/provider"

import { AlternativeLoginForSaml } from "./AlternativeLogin"
import {
  FormTitle, LanguageSelector, NewsBlock, Separator, SubmitButton
} from "../../components"
import { useLoginService } from "../../providers/LoginService"

export const LoginWithSamlScreenContent = () => {
  const { i18n } = useTranslations()
  const { loginWithSaml } = useLoginService()

  return <>
    <FormTitle sx={{ marginBottom: "10px" }}>
      {`${i18n("Account.Login:LoginWith")} SAML 2.0`}
    </FormTitle>

    <SubmitButton label={i18n("Account.Login:Login")} onClick={loginWithSaml}/>

    <Separator/>
    <AlternativeLoginForSaml/>
    <NewsBlock/>
    <LanguageSelector/>
  </>
}
